import React, { Component, Fragment } from 'react';

interface FjTableRowProps {
  children?: React.ReactNode;
  _rowIndex?: number;
}

class FjTableRow extends Component<FjTableRowProps> {
  renderTableCells(): React.ReactNode {
    return React.Children.map(this.props.children, (cell, index) => {
      const element = cell as React.ReactElement<{ children?: React.ReactNode }>;
      const cellProps = {
        ...element.props,
        _rowIndex: this.props._rowIndex,
        _colIndex: index + 1,
        key: `cell-${this.props._rowIndex}-${index + 1}`,
      };

      return React.cloneElement(element, cellProps, element.props.children);
    });
  }

  render(): React.ReactNode {
    return <Fragment>{this.renderTableCells()}</Fragment>;
  }
}

export default FjTableRow;
